import React, { memo } from 'react'
import { EINForm } from 'src/components/ein/EINForm'
import { SecureWrapper } from '../layout/SecureWrapper'

const EINComponent = () => {
  return (
    <SecureWrapper>
      <EINForm />
    </SecureWrapper>
  )
}

export const EIN = memo(EINComponent)
